<div class="sa-setup">
  <div class="sa-setup-wrapper">
    <sa-icon img="{{product_logo}}" imgWidth="110" imgHeight="38" ></sa-icon>
    <div class="flex-center h-100">
      @if(showInitialLoader){
        
      }@else{
        @if(!messageView){
        <div class="sa-form-container">
          @if(isLoading){
          <div class="sa-form-overlay"></div>
          } @if(toast){
          <sa-toast
            class="block"
            [subHeading]="toast.subHeading"
            [status]="toast.status"
          ></sa-toast>
          }
          <div class="title">Finish setting up your account</div>

          @if(fields){
          <form [formGroup]="form" (ngSubmit)="onSubmit()">
            <formly-form
              [form]="form"
              [model]="model"
              [fields]="fields"
              (modelChange)="modelChangeHandler($event)"
            >
            </formly-form>

            <!-- [disabled]="!form.valid" -->
            <sa-button
              [isSubmit]="true"
              text="Get Started"
              type="primary"
              size="medium"
              [state]="!!form.valid ? 'default' : 'disabled'"
              width="100%"
              [showSpinner]="isLoading"
            ></sa-button>
          </form>
          }

          <div class="text text-12">
            By signing up, I agree to the Saras
            <a [href]="privacyPolicy" class="link" target="_blank">Privacy Policy</a> and
            <a [href]="termsOfUse" class="link" target="_blank">Terms of Service</a>
          </div>
        </div>
        }@else{
        <sa-message-view
          [props]="messageView"
          (onClick)="onMessageViewEvent($event)"
        ></sa-message-view>
        }
      }
    </div>
  </div>
</div>
